class HeroSlider {
  constructor(container) {
    this.container = container;
    this.autoplayEnabled = false;
    this.autoplayCarouselSpeed = 5 * 1000;
    this.splideInstance = null;
    this.init();
  }

  init() {
    this.handleSplideSlider(this.container);
  }

  handleSplideSlider(container) {
    const heroSliderSlideshow = container.querySelector('[hero-slider-slideshow]');

    if (heroSliderSlideshow) {
      this.splideInstance = new Splide(heroSliderSlideshow, {
        type: 'slide',
        perPage: 1,
        perMove: 1,
        mobileFirst: true,
        autoplay: this.autoplayEnabled,
        interval: this.autoplayCarouselSpeed,
        arrows: false,
        pagination: true,
        speed: 1000,
        trimSpace: 'move',
        breakpoints: {
          767: {
            perPage: 1,
            perMove: 1,
            pagination: false,
            centerMode: true,
            variableWidth: true,
          },
          1439: {
            perPage: 1,
            perMove: 1
          }
        },
      }).mount();
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const heroSliderSection = document.querySelector('[component-hero-slider]');
  if (heroSliderSection) {
    const heroSlider = new HeroSlider(heroSliderSection);

  }
});
